import React from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { FormControl, Select, Stack } from "@chakra-ui/react";
import { ThemedStyledInput } from "../../../../../components/Styled";
import FieldErrorMessage from "../../../../../components/FieldErrorMessage/FieldErrorMessage";
import { CustomButton } from "../../../../../components/Styled/StyledButtons";
import Icon from "../../../../../@core/components/icon";

const validationSchema = Yup.object({
    title: Yup.string().max(100, 'Maximum 100 characters'),
    status: Yup.string()
});

const AlbumSearchFilter = ({ onFilterChange }) => {
    return (
        <Formik
            initialValues={{
                title: '',
                status: ''
            }}

            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                if (!values.title && !values.status) {
                    onFilterChange({ title: '', status: '' });
                } else {
                    onFilterChange(values);
                }
                setSubmitting(false);
            }}
            onReset={() => {
                onFilterChange({ title: '', status: '' });
            }}
        >
            {({ handleSubmit, resetForm }) => (
                <Form>
                    <Stack spacing={2} direction="row" align="center">
                        <FormControl flex="2">
                            <Field
                                as={ThemedStyledInput}
                                id="title"
                                name="title"
                                type="text"
                                placeholder="Search by Title"
                            />
                            <FieldErrorMessage name="title" />
                        </FormControl>
                        <FormControl flex="1">
                            <Field
                                as={Select}
                                name="status"
                                placeholder=" -- Filter by Status -- "
                                id="status"
                            >
                                <option value="draft">Draft</option>
                                <option value="published">Published</option>
                                <option value="archived">Archived</option>
                            </Field>
                        </FormControl>
                        <CustomButton
                            onClick={handleSubmit}
                            type="search"
                            tooltipLabel="Search"
                            icon={<Icon icon="bi:search" />}
                            showLabel={false}
                        >
                            Search
                        </CustomButton>
                        <CustomButton
                            type="reset"
                            onClick={() => {
                                resetForm();
                                onFilterChange({ title: '', status: '' });
                            }}
                            tooltipLabel="Clear Filters"
                            icon={<Icon icon="radix-icons:reset" />}
                            showLabel={false}
                        >
                            Clear
                        </CustomButton>
                    </Stack>
                </Form>
            )}
        </Formik>
    );
};

export default AlbumSearchFilter;
